(function () {
'use strict';

angular
    .module('adminGovernanceProcessRoutes', [
        'adminGovernanceProcessControllers',
        'actionPlanModule',
        'governanceProcessModule'
    ])
    .config(router);

router.$inject = ['$stateProvider'];

function router($stateProvider) {

    $stateProvider
            .state('admin.governanceProcess', {
                url: '/GovernanceProcess',
                resolve: {
                    governanceProcessTypes: ['grcGovernanceProcessService', function (service) {
                        return service.getProcessTypes();
                    }],
                    governanceProcesses: ['grcGovernanceProcessService', function (service) {
                        return service.getActiveProcesses();
                    }]
                },
                views: {
                    'mainContent@admin': {
                        templateUrl: require('./adminGovernanceProcessList.tpl.html'),
                        controller: 'AdminGovernanceProcessListController'
                    }
                }
            })
            .state('admin.governanceProcess.edit', {
                url: '/{governanceProcessId:int}',
                views: {
                    'mainContent@admin': {
                        templateUrl: require('./editGovernanceProcess.tpl.html'),
                        controller: 'EditGovernanceProcessController',
                        resolve: {
                            fiscalYears: ['grcGovernanceProcessService', function (service) {
                                return service.getFiscalYears();
                            }],
                            govProcess: ['$stateParams', 'grcGovernanceProcessService', function ($stateParams, service) {
                                return service.getById($stateParams.governanceProcessId);
                            }],
                            govProcessType: ['govProcess', function (govProcess) {
                                return govProcess.GovernanceProcessType;
                            }]
                        }
                    }
                }
            })
            .state('admin.governanceProcess.add', {
                url: '/{governanceProcessTypeValue}/Add',
                views: {
                    'mainContent@admin': {
                        templateUrl: require('./editGovernanceProcess.tpl.html'),
                        controller: 'EditGovernanceProcessController',
                        resolve: {
                            fiscalYears: ['grcGovernanceProcessService', function (service) {
                                return service.getFiscalYears();
                            }],
                            govProcessType: ['$stateParams', 'governanceProcessTypes', function ($stateParams, governanceProcessTypes) {
                                return _.find(governanceProcessTypes, { Value: $stateParams.governanceProcessTypeValue });
                            }],
                            govProcess: function () { return {}; }
                        },
                    }
                }
            });
    }
})();